import { env } from '@/env';
import { isNativePlatform } from '@/lib/native/platform';

/**
 * Origin to use for Supabase auth email-redirect links (signup confirmation +
 * password reset).
 *
 * On the web, `window.location.origin` is the live site origin — correct.
 *
 * Inside the Capacitor native app the runtime origin is `capacitor://localhost`
 * (iOS) / `http://localhost` (Android). That is NOT a usable email-link target
 * and is not in Supabase's redirect allowlist, so a confirmation/reset link
 * built from it would be dead on the native app. There we use the hosted web
 * origin from `VITE_APP_BASE_URL` instead: the link opens the real site, the
 * user completes confirmation/reset, then returns to the app to sign in.
 * (Universal Links — docs/capacitor-mobile.md #4 — would later let that https
 * link open the app directly; this keeps it functional until then.)
 */
export function authRedirectOrigin(): string {
  if (isNativePlatform()) {
    const base = env.VITE_APP_BASE_URL?.replace(/\/+$/, '');
    if (base) return base;
    // eslint-disable-next-line no-console
    console.warn(
      '[auth] VITE_APP_BASE_URL is unset on a native build — email redirect links ' +
        'will point at the in-app origin and will not work. Set VITE_APP_BASE_URL.',
    );
  }
  return window.location.origin;
}
